/**
 * @module custom-event-names
 * @ignore
 * __VERSION_HERE__
 */

var CUSTOM_EVENT_NAMESPACE = '@nikeCustomEvent';
export var CART_COUNT_UPDATED_EVENT_NAME = "".concat(CUSTOM_EVENT_NAMESPACE, "/cartCountUpdated");
export var CART_UPDATED_EVENT_NAME = "".concat(CUSTOM_EVENT_NAMESPACE, "/cartUpdated");
export var LOCATION_UPDATED_EVENT_NAME = "".concat(CUSTOM_EVENT_NAMESPACE, "/locationUpdated");
export var UPDATED_SHOP_DATA_EVENT = "".concat(CUSTOM_EVENT_NAMESPACE, "/updatedSharedShopData");
export var MERGED_CARTS_EVENT = "".concat(CUSTOM_EVENT_NAMESPACE, "/mergedCarts");